import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-devkit',
  template: `
    <p>
      devkit works!!!
    </p>
  `,
  styles: []
})
export class DevkitComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
